import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=245c3558&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"
import style0 from "./Chatbot.vue?vue&type=style&index=0&id=245c3558&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c3558",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245c3558')) {
      api.createRecord('245c3558', component.options)
    } else {
      api.reload('245c3558', component.options)
    }
    module.hot.accept("./Chatbot.vue?vue&type=template&id=245c3558&scoped=true", function () {
      api.rerender('245c3558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Chatbot.vue"
export default component.exports